import type { Space } from '@mail/cross-sizes-utils';
import {
    type BillingData,
    type BillingDataPartner,
    type BillingDataPeriod,
    type BillingDataResponse,
    BillingDataPlatform,
} from 'reactApp/api/billing/data/BillingDataAPICall.types';
import { vkMusicBundleTariffList } from 'reactApp/appHelpers/featuresHelpers/features/vkMusicBundle';

export type BillingDataSubscriptionRecord = Record<string, BillingDataSubscriptionInfo>;

export interface GetBillingDataRequesSuccessAction {
    billingData: BillingDataResponse;
}

type BillingDataActionRadar = 'giftreceived' | 'giftsent' | 'paidinfo' | 'subs';

export interface GetBillingDataAction {
    /** @description детализация в xray для чего именно инициализириуем получение информации */
    radar: BillingDataActionRadar;
}
export interface UpdateBillingDataAction {
    /** @description детализация в xray для чего именно обновляем информацию */
    radar: BillingDataActionRadar;
    count?: number;
    showSnackbar?: boolean;
    trackFields?: (keyof BillingData)[];
}

export interface BillingPaidInfo {
    trialExpires: number;
    paidExpires: number;
}

export interface BillingReferralProgram {
    id: string;
    type: BillingDataPlatform;
    start: number;
    expires: number;
    autorenewable: boolean;
    owner: {
        email: string;
    };
    quota: Space;
}

export interface BillingDataState {
    activeSubscriptionId?: string;
    subscription: BillingDataSubscriptionRecord;
    receivedGifts: BillingDataReceivedGiftsRecord;
    sentGifts: BillingDataSentGiftsRecord;
    paidInfo: BillingPaidInfo;
    referral: BillingReferralProgram[];
    rawBillingData: BillingDataResponse;
    isLoading: boolean;
    isLoaded: boolean;
    hasError: boolean;
}

export enum BillingDataSubscriptionInfoStatus {
    ACTIVE = 'ACTIVE',
    FINISHED = 'FINISHED',
    SUSPENDED = 'SUSPENDED',
    GRACE = 'GRACE',
    HOLD = 'HOLD', // Пока нет
    LAPSED = 'LAPSED',
    WAITING = 'WAITING',
}

export interface BillingDataSubscriptionInfo {
    id: string;
    type: BillingDataPlatform;
    start: number;
    status: BillingDataSubscriptionInfoStatus;
    expires: number;
    renewAt?: number;
    icon: string;
    productId: string;
    period?: string;
    space: Space;
    autorenewal?: boolean;
    // Цена покупки подписки (для подписки со скидкой тут будет указана скидочная цена, для подписки с триалом будет 0)
    purchaseCost?: number;
    // Цена продления подписки
    renewalCost?: number;
    renewable: boolean;
    isTrial: boolean;
    isPrepaid: boolean;
    flags: Record<string, boolean>;
    accountLink?: string;
    partner?: BillingDataPlatform | BillingDataPartner;
    isMail: boolean;
    currentPeriod?: BillingDataPeriod;
}

export enum BillingDataNotifications {
    updateSuccess = 'BILLING_DATA_UPDATE_SUCCESS',
    updateFailure = 'BILLING_DATA_UPDATE_FAILURE',
}

export interface BillingDataReceivedGift {
    expires: number;
    id: string;
    start: number;
    created: number;
    productId: string;
    discount?: { web?: string };
    space: Space;
}
export interface BillingDataSentGift {
    isGifted: boolean;
    created: number;
    id: string;
    // NOTE: для обратной совместимости code === gift_id
    code: string;
    expires: number;
    start: number;
    space: Space;
}

export type BillingDataReceivedGiftsRecord = Record<string, BillingDataReceivedGift>;

export type BillingDataSentGiftsRecord = Record<string, BillingDataSentGift>;

export interface BaseSubscriptionType {
    base: true;
    id: 'base';
    icon: string;
    space: Space;
    type: BillingDataPlatform.base;
}

export const isBaseSubscription = (subscription): subscription is BaseSubscriptionType => {
    return (subscription as BaseSubscriptionType).type === BillingDataPlatform.base;
};

export const isVkMusicWebSubscription = (subscription): subscription is BillingDataSubscriptionInfo => {
    return vkMusicBundleTariffList.includes(subscription.productId);
};
